import { toggleMark } from 'prosemirror-commands';
import { isMarkActive } from '../../../utils/marks';
import { ColorSpecs, colorType } from './ColorSpecs';
import { colorAction, colorMarkName } from './const';
import { chainAND, parseStyleColorValue, validateClassNameColorName } from './utils';
import './colors.css';
export { colorClassName, Colors } from './const';
export { colorMarkName, colorType } from './ColorSpecs';
export const Color = (builder) => {
    builder.use(ColorSpecs, {
        validateClassNameColorName,
        parseStyleColorValue,
    });
    builder.addAction(colorAction, ({ schema }) => {
        const type = colorType(schema);
        return {
            isActive: (state) => Boolean(isMarkActive(state, type)),
            isEnable: toggleMark(type),
            run: (state, dispatch, _view, attrs) => {
                const params = attrs;
                const hasMark = isMarkActive(state, type);
                if (!params || !params[colorMarkName]) {
                    if (!hasMark)
                        return true;
                    // remove mark
                    return toggleMark(type, params)(state, dispatch);
                }
                if (hasMark) {
                    // remove old mark, then add new with new color
                    return chainAND(toggleMark(type), toggleMark(type, params))(state, dispatch);
                }
                // add mark
                return toggleMark(type, params)(state, dispatch);
            },
            meta(state) {
                var _a;
                return (_a = type.isInSet(state.selection.$to.marks())) === null || _a === void 0 ? void 0 : _a.attrs[colorMarkName];
            },
        };
    });
};
